<template>
    <div class="sdr-box">
        <h5 class="box-title">{{ aboutsundair[getCurrentLocale] }}</h5>
        <p v-html="aboutsundairtext[getCurrentLocale]"></p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            aboutsundair: {
                en: 'About SUNDAIR',
                de: 'Über SUNDAIR',
            },
            aboutsundairtext: {
                en: '<strong>SUNDAIR</strong> is a young and independent Airline founded in 2016 with headquarters in Stralsund and bases at Kassel-Calden Airport, Berlin-Brandenburg, Dresden and Bremen.<br />SUNDAIR operates holiday flights to the most beautiful destinations in the Mediterranean, the Red Sea and the Canary Islands.<br />The airline also operates special and charter flights.<br />The modern fleet currently consists of five aircraft, 3 Airbus A320-214 and 2 Airbus A319-112.',
                de: '<strong>SUNDAIR</strong> ist eine 2016 gegründete, junge und unabhängige Fluggesellschaft mit Sitz in Stralsund und Basen am Flughafen Kassel-Calden, Berlin-Brandenburg, Dresden und Bremen.<br />SUNDAIR bedient im Ferienflugverkehr die schönsten Ziele im Mittelmeerraum, am Roten Meer und auf den Kanarischen Inseln.<br />Zudem operiert die Airline im Sonder- und Charterverkehr.<br />Die moderne Flotte besteht derzeit aus fünf Flugzeugen, 3 vom Typ Airbus A320-214 und 2 vom Typ Airbus A319-112.',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: {
        ...mapGetters(['getCurrentLocale']),
    }, // eof computed{}
    /* <<< ****************************************************************/
};
</script>

<style scoped>
</style>